import React, { useState } from "react"
import styled from "styled-components"
import { Spacer } from "../styles/common"
import { ChevronDown } from "@omnichannel/ace-b2b-elements"

const AccordionContainer = styled.div`
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : "transparent"};
  margin: 1rem;
  border-bottom: 1px solid #d5cecf;
  @media (max-width: 767px) {
    margin: 1rem 0rem;
  }
`

const AccordionTitleStyle = styled.div`
  padding: ${props => (props.titlePadding ? props.titlePadding : "1.95rem 2.2rem")};
  cursor: pointer;
  color: ${props => (props.fontColor ? props.fontColor : "#3E3F42")};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 2.2rem;
  color: #3e3f42;
  @media (max-width: 767px) {
    font-size: 1.8rem;
    font-weight: 500;
    padding: ${props => (props.titlePadding ? props.titlePadding : "0.8rem 2.2rem 1.6rem 2.2rem")};
  }
`

const IconStyle = styled.div`
  cursor: pointer;
  width: auto;
  transform: ${props => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  -ms-transform: ${props => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  -webkit-transform: ${props =>
    props.isOpen ? "rotate(180deg)" : "rotate(0deg)"};
  -webkit-transition: transform 0.5s ease-in-out;
  -ms-transition: transform 0.5s ease-in-out;
  transition: transform 0.5s ease-in-out;
  -o-transition: transform 0.5s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
`

const AccordionBox = styled.div`
  max-height: ${props => (props.isOpen ? (props.maxHeight ? props.maxHeight : "150rem") : "0")};
  overflow: scroll;
  transition: max-height 0.5s ease-in-out;
  -webkit-transition: max-height 0.5s ease-in-out;
  -moz-transition: max-height 0.5s ease-in-out;
  -o-transition: max-height 0.5s ease-in-out;
  -ms-overflow-style: none;
  scrollbar-width: none;
  & ::-webkit-scrollbar {
    display: none;
  }
`

const TitleBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

const AccordionContent = props => {
  return (
    <AccordionBox isOpen={props.isOpen} maxHeight={props.maxHeight}>
      {props.children}
      <Spacer height="1rem" />
    </AccordionBox>
  )
}

const AccordionTitle = props => {
  return (
    <AccordionTitleStyle onClick={props.onClick} fontColor={props.fontColor} titlePadding={props.titlePadding}>
      {props.children}
      <IconStyle isOpen={props.isOpen}>
        <ChevronDown width={"10"} height={"20"} color={"#7C878E"} />
      </IconStyle>
    </AccordionTitleStyle>
  )
}

export default function CommonAccordion(props) {
  const {
    title,
    subtitle,
    content,
    trailing,
    backgroundColor,
    fontColor,
    titlePadding,
    willSetOpen = () => { },
    initialOpen = false,
    maxHeight = "150rem"
  } = props
  const [open, setOpen] = useState(initialOpen)

  const toggleAccordion = _ => {
    let tempVal = open
    setOpen(!tempVal)
    willSetOpen(!tempVal)
  }

  return (
    <AccordionContainer backgroundColor={backgroundColor}>
      <AccordionTitle
        onClick={() => toggleAccordion()}
        isOpen={open}
        fontColor={fontColor}
        titlePadding={titlePadding}
      >
        <TitleBar>
          <TitleContainer>
            <div>{title}</div>
            {subtitle && <div>{subtitle}</div>}
          </TitleContainer>
          {trailing}
        </TitleBar>
      </AccordionTitle>
      <AccordionContent isOpen={open} maxHeight={maxHeight}>{content}</AccordionContent>
    </AccordionContainer>
  )
}
